export const listUserLogs = `query ListLogs(
    $actionOn: String
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLogs(
      actionOn: $actionOn
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        app
        action
        actionBy
        actionOn
        currVal
        newVal
        ipAddress
        browserDetails
      }
      nextToken
    }
  }
  `;